var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/index.js";

import React from 'react';
import pt from 'prop-types';
import ViewPortMain from './ViewPortMain';
import OpenPosition from './OpenPosition';
import Nut from './Nut';
import Board from './Board';

const Neck = ({
  tuning,
  nrOfFrets,
  dimensions,
  skinType,
  selectedStrings,
  fretHighlight,
  fretHighlightColor
}) => {
  const {
    openWidth,
    nutWidth,
    stringHeight
  } = dimensions;
  const boardHeight = tuning.length * stringHeight;
  const boardWidth = 100 - openWidth - nutWidth;
  return /*#__PURE__*/React.createElement(ViewPortMain, {
    height: boardHeight,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(OpenPosition, {
    width: openWidth,
    tuning: tuning,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Nut, {
    skinType: skinType,
    width: nutWidth,
    offset: openWidth,
    tuning: tuning,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Board, {
    skinType: skinType,
    width: boardWidth,
    offset: nutWidth + openWidth,
    tuning: tuning,
    nrOfFrets: nrOfFrets,
    selectedStrings: selectedStrings,
    fretHighlight: fretHighlight,
    fretHighlightColor: fretHighlightColor,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }));
};

Neck.propTypes = {
  tuning: pt.arrayOf(pt.string).isRequired,
  nrOfFrets: pt.number.isRequired,
  dimensions: pt.shape({}).isRequired,
  skinType: pt.string.isRequired,
  selectedStrings: pt.arrayOf(pt.string).isRequired,
  fretHighlight: pt.arrayOf(pt.number).isRequired,
  fretHighlightColor: pt.string.isRequired
};
export default Neck;

